import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dbb0c2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "article-content-container" }
const _hoisted_2 = {
  key: 0,
  class: "container-item article-detail-inner"
}
const _hoisted_3 = { class: "article-title" }
const _hoisted_4 = { class: "article-author article-item" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "author-item"
}
const _hoisted_7 = { class: "author-item" }
const _hoisted_8 = ["href", "download"]
const _hoisted_9 = ["poster"]
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "article-item stock-box"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "article-content article-item" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 1,
  class: "container-item article-detail-inner"
}
const _hoisted_17 = { class: "article-content article-item" }
const _hoisted_18 = { class: "headline-news-content plain-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StarContentAudio = _resolveComponent("StarContentAudio")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isNormalArticle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.article.title), 1),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.authorLogo)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "author-item logo-img",
                  src: _ctx.authorLogo,
                  alt: ""
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.authorName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.authorName), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_7, "发布于 " + _toDisplayString(_ctx.showTimeText), 1),
            (_ctx.pdfUrl)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  class: "author-item pdf-link",
                  href: _ctx.pdfUrl,
                  download: _ctx.pdfName,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, " PDF下载 ", 8, _hoisted_8))
              : _createCommentVNode("", true)
          ]),
          (_ctx.video.url)
            ? (_openBlock(), _createElementBlock("video", {
                key: 0,
                id: "videoPlayer",
                class: "article-video",
                poster: _ctx.video.coverURL,
                controls: ""
              }, [
                _createElementVNode("source", {
                  src: _ctx.video.url
                }, null, 8, _hoisted_10)
              ], 8, _hoisted_9))
            : _createCommentVNode("", true),
          (_ctx.displayStockList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayStockList, (item, index) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: `${item.stockCode}-${index}`,
                    class: "pointer stock-item",
                    onClick: ($event: any) => (_ctx.onStockClick(item))
                  }, [
                    _createTextVNode(_toDisplayString(item.stockName) + " ", 1),
                    (item.rate)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass({ rise: item.type === 'up', fall: item.type === 'down' })
                        }, _toDisplayString(_ctx.formatArticleRate(item.rate)), 3))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, "--"))
                  ], 8, _hoisted_12))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.audioUrl || _ctx.htmlContent)
              ? (_openBlock(), _createBlock(_component_StarContentAudio, {
                  key: 0,
                  "media-file": _ctx.audioUrl,
                  "text-content": _ctx.htmlContent
                }, null, 8, ["media-file", "text-content"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              ref: "contentRef",
              class: "headline-news-content",
              innerHTML: _ctx.htmlContent
            }, null, 8, _hoisted_15)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            (_ctx.plainContent)
              ? (_openBlock(), _createBlock(_component_StarContentAudio, {
                  key: 0,
                  "text-content": _ctx.plainContent
                }, null, 8, ["text-content"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.plainContent), 1)
          ])
        ]))
  ]))
}